<template>
  <div class="main-body">
    <div class="header">入住管理</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-input placeholder="输入姓名" v-model="elderlyName" clearable style="width:120px;margin-right: 10px;"></el-input>

          <el-select v-model="status" placeholder="入住状态" style="margin-right: 10px;">
            <el-option
                v-for="item in statusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

          <el-date-picker
              style="width: 250px;margin-right: 10px;" size="mini"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              v-model="search.date"
              type="daterange"
              align="right"
              placeholder="选择日期范围"
              :default-value="search.date"
              :picker-options="pickerOptions"
              range-separator=" ~ ">
          </el-date-picker>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" v-loading="loading" border
                highlight-current-row @row-click='rowClick'>

        <el-table-column fixed prop="elderlyName" label="姓名" width="100px"></el-table-column>

        <el-table-column label="入住类型" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.checkinType == '1'">院护</span>
            <span v-if="scope.row.checkinType == '2'">家护</span>
            <span v-if="scope.row.checkinType == '3'">日护</span>
          </template>
        </el-table-column>

        <el-table-column label="入住状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '0'">未入住</span>
            <span v-if="scope.row.status == '1'">已入住</span>
            <span v-if="scope.row.status == '2'">已退住</span>
          </template>
        </el-table-column>

        <el-table-column prop="checkinSetmealName" label="护理套餐" width="120px"></el-table-column>

        <el-table-column prop="liveAddress" label="床位号" width="150px"></el-table-column>

        <el-table-column prop="priceMonth" label="月费用" width="150px"></el-table-column>
        <el-table-column prop="univalenceTrue" label="实际费用" width="150px"></el-table-column>

        <el-table-column prop="elderlyFund.balance" label="余额"></el-table-column>
        <el-table-column prop="elderlyFund.imprest" label="备用金"></el-table-column>
        <el-table-column prop="elderlyFund.advance" label="预交金"></el-table-column>

        <el-table-column prop="beginTime" :formatter="timefilter" width="180" label="开始时间"></el-table-column>
        <el-table-column prop="endTime" :formatter="timefilter" width="180" label="结束时间"></el-table-column>


        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
<!--            <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>-->

            <span v-if="scope.row.status == '0'">未入住</span>
            <span v-if="scope.row.status == '1'">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="settlefuc2(scope.$index, scope.row)">退住</el-button>
            </span>
            <span v-if="scope.row.status == '2'"></span>

          </template>
        </el-table-column>


      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <el-dialog title='结算' :visible.sync="settleDialog" class="dialog" width='600px' center top='30vh' :close-on-click-modal='false'>
      <el-form :model="settleForm" :rules="rules" ref="settleForm">
        <el-row>
          <el-col :span="12" class="item">
            <el-form-item label="预估结算金额(元)" required>
              <el-input v-model="settleForm.moneyPlan" disabled placeholder="请输入预估结算金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="item">
            <el-form-item label="实际结算金额(元)" required prop="total">
              <el-input type="number" v-model="settleForm.total" @change='getBalance' placeholder="请输入实际结算金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="item">
            <el-form-item label="剩余余额(元)" required prop="refundMoney">
              <el-input type="number" v-model="settleForm.refundMoney" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="item">
            <el-form-item label="备注" required prop="remarks">
              <el-input v-model="settleForm.remarks" type="textarea" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="settleDialog=false">取 消</el-button>
        <el-button type="primary"  @click="settleSub('settleForm')">提交</el-button>
      </div>
    </el-dialog>

    <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeGetElderly="closeGetElderly" v-bind:setmealList="setmealList" v-bind:ListBerth="ListBerth" v-on:getList="getList"></GetElderly>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:ListBerth="ListBerth"  v-bind:setmealList="setmealList" v-on:getList="getList"></Edit>
    <Detail ref="myDetail" v-show="showModalDetail" v-on:closeDetail="closeDetail"></Detail>
    <RoomChange ref="myRoomChange" v-show="showModalRoomChange" v-on:closeRoomChange="closeRoomChange" v-bind:ListBerth="ListBerth"  v-bind:setmealList="setmealList" v-on:getList="getList"></RoomChange>

  </div>
</template>

<script>
import Edit from "./Edit";
import GetElderly from "./GetElderly";
import RoomChange from "./RoomChange";
import Detail from "./Detail";
import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data() {
    return {
      loading: true,
      menuButtonList:null,

      disabledAdd:false,
      disabledIn:true,
      disabledEdit:true,
      disabledSettlement:true,
      disabledRoomChange:true,
      disabledContract:true,
      disabledDetail:true,

      elderlyName:"",

      showModalAdd: false,
      showModalRoomChange: false,
      showModalZiXuanRoomChange:false,
      datetimerangeValue: '',
      showModalEdit: false,
      showModalZiXuanEdit:false,
      showModalDetail:false,
      batchDialog: false,
      settleDialog: false,
      elderlyBalance: '',

      settleForm: {
        moneyPlan: null,
        refundMoney: null,
        total: null,
        remarks: null,
        isRefund:2,
      },

      rules:{
        totalMoney:[
          { required: true, message: '请输入实际结算金额', trigger: 'blur' },
          {
            pattern: /^(\d?)+(\.\d{0,2})?$/,
            message: '小数点后数字不能超过两位', trigger: 'blur'
          },
        ],
        remarks:[
          { required: true, message: '请输入备注', trigger: 'blur' },
        ],
        isRefund:[
          { required: true, message: '请选择是否退款', trigger: 'blur' },
        ],
      },

      showModalGetElderly: false,
      ListBerth: null,
      setmealList: null,

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,


      checkInfo:'',


      search: {
        date:[],
      },

      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            end.setHours(23, 59, 59);
            const start = new Date(end);
            start.setTime(end.getTime() - 3600 * 1000 * 24 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 7 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 30 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 90 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setHours(23, 59, 59);
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 365 + 1000);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      status:-1,
      statusArr: [{
        value: -1,
        label: '全部状态'
      },{
        value: 1,
        label: '入住中'
      },{
        value: 2,
        label: '已退住'
      }],


    }
  },

  created() {

    const end = new Date();
    const start = new Date(end - 1000 * 60 * 60 * 24 * 360*10);
    this.search.date = [start, end];


    this.init();
    this.getList();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  components: {
    Edit,GetElderly,RoomChange,Detail
  },
  methods: {

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    monthFirstDay:function (time) {  //是我用来获取当月的第一天的
      let date = new Date(time)
      let year = date.getFullYear()
      let month = (date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))
      let day = '01';
      return `${year}-${month}-${day}`

    },
    nowDay:function (time) { //handleTimeNew是获取今天的日期
      let date = new Date(time)
      let year = date.getFullYear()
      let month = (date.getMonth() + 1) > 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))
      let day = date.getDate() > 10 ? date.getDate() : ('0' + date.getDate())
      return `${year}-${month}-${day}`
    },

    init(){
      this.getSetMeal();
    },

    getSetMeal:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/List",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.setmealList=response.data.data
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    checkInSub(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Checkin/CheckinToElderly",
        data:{
          timeStr:timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          checkinCode:this.checkInfo.checkinCode
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.batchDialog=false
          this.getList()
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    getTofiexd(row, column, cellValue){
      var data=cellValue
      var list=cellValue.toString().split(".")
      if(list.length==2){
        if(list[1].length>2){
          data=cellValue.toFixed(2)
        }
      }
      return data
    },

    getBalance(){
      this.settleForm.refundMoney=this.elderlyBalance-this.settleForm.total
      if(this.settleForm.refundMoney<0){
        this.$alert('账户余额不足，请充值后结算', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action)
            this.settleDialog=false
          }
        });
      }
    },

    settlefuc2(index,row){
      this.checkInfo = row;

      this.settleForm.moneyPlan = 0;
      this.settleForm.total=0;

      this.elderlyBalance = row.balance;
      this.settleForm.refundMoney = this.elderlyBalance - this.settleForm.total

      this.settleDialog=true
      //this.$refs.settleForm.resetFields();

    },
    settlefuc(index,row){

      this.checkInfo = row;

      var checkinCode=row.checkinCode

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Checkin/SettleMoney",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          checkinCode:checkinCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {

          this.settleForm.moneyPlan = response.data.data.moneyPlan;
          this.settleForm.total=response.data.data.moneyPlan;

          this.elderlyBalance = row.balance;
          this.settleForm.refundMoney = this.elderlyBalance - this.settleForm.total

          if(this.settleForm.refundMoney<0){
            this.$message.warning('账户余额不足，请充值后结算')
          }else{
            this.settleDialog=true
            this.$refs.settleForm.resetFields();
          }

        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    settleSub(settleForm){
      this.$refs[settleForm].validate((valid) => {
        if(valid){

          var checkinCode=this.checkInfo.checkinCode
          var refundMoney=this.settleForm.refundMoney

          if(this.settleForm.isRefund==2){
            refundMoney=0
          }

          this.$axios({
            method: 'post',
            url: this.$shopUrl + "Checkin/RetreatSettle",
            data: {
              timeStr: timeStr,
              sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
              staffCode: getStaffCode(),
              checkinCode:checkinCode,
              remarks:this.settleForm.remarks,
              total:this.settleForm.total,
              isRefund:this.settleForm.isRefund,
              refundMoney:refundMoney,
            }
          }).then((response) => {
            //console.log(response);
            if (response.data.error == 0) {
              this.settleDialog=false
              this.$refs.settleForm.resetFields();
              this.getList()
            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }).catch(function (error) {
            console.log(error);
          });
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    getList() {

      if(this.search.date == null){
        this.search.date = ['',''];
      }

      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Checkin/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyName:this.elderlyName,
          status:this.status,
          startTime: this.search.date[0],
          endTime: this.search.date[1],
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((response) => {
        //console.log(response);
        this.loading = false;

        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    handleEdit(index,row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },


    handleInfo(index,row) {
      this.$refs.myDetail.init(row);
      this.showModalDetail = !this.showModalDetail;
    },
    closeDetail: function () {
      this.showModalDetail = !this.showModalDetail;
    },

    //入住
    handleIn() {
      if(this.checkInfo.balance<=0){
        this.$message.error('老人余额不足，请充值！')
        return;
      }
      this.$confirm(this.checkInfo.elderlyName+'确认入住, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.checkInSub();

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    toggleModalAdd: function () {
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init();
    },
    closeGetElderly: function () {
      this.showModalGetElderly = !this.showModalGetElderly;
    },
    closeRoomChange: function () {
      this.showModalRoomChange = !this.showModalRoomChange;
    },

    toggleModalEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },



    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },


    rowClick(row){
      this.checkInfo=row
    }

  }
}
</script>
